<template>
    <modal ref="modalRegistrarPago" titulo="Registrar Pago" no-aceptar icon="aprobar" adicional="Pagar" tamano="modal-lg" @adicional="pagar()">
        <div class="row mx-0 justify-center">
            <div class="col-10">
                <p class="text-general f-14 pl-3">Valor a pagar</p>
                <input-miles v-model="valorPagar" class="w-100" :money-options="money" />
            </div>
            <div class="col-10 text-general f-15 mt-4">
                <p class="text-general f-14 pl-3">Comentario</p>
                <el-input v-model="comentarioPago" type="textarea" maxlength="300" rows="3" />
            </div>
        </div>
    </modal>
</template>

<script>
import pagos from '~/services/pagos/pagos'
export default {
    data(){
        return{
            valorPagar: '',
            comentarioPago: '',
            valorMaximo: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '$ ',
                precision: 2,
                masked: false
            },
            datos: {}
        }
    },
    methods: {
        toggle(datos){
            this.datos = _.cloneDeep(datos)
            this.valorMaximo = this.datos.total_debe
            this.valorPagar = this.datos.total_debe
            this.money.precision = this.datos.decimales_moneda
            this.$refs.modalRegistrarPago.toggle();
        },
        async pagar(){
            try {
                if(this.valorPagar == 0) return this.notificacion('Advertencia', 'El valor debe ser mayor a cero', 'warning')
                if(this.valorPagar > this.valorMaximo) return this.notificacion('Advertencia', `El valor maximo a pagar es de ${this.valorMaximo}`, 'warning')

                const form = {
                    id_pedido: this.datos.id_pedido,
                    valor: this.valorPagar,
                    comentario: this.comentarioPago,
                }

                const { data } = await pagos.registarPagoCliente(form)
                if(data.exito){
                    this.$emit('saved')
                    this.$refs.modalRegistrarPago.toggle();
                }

            } catch (error){
                this.error_catch(error)
            }
        }
    }
}
</script>